import { TablePagination } from "@mui/material";
import dayjs from "dayjs";
import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getHost, disableHost } from "../../store/host/host.action";
import { OPEN_HOST_DIALOG } from "../../store/host/host.type";
import femaleImage from "../../assets/img/female.png";
import maleImage from "../../assets/img/maleImage.png";
import HostDialogue from "../Dialog/HostDialogue";
import TablePaginationActions from "../../util/Pagination";
import HostEdit from "../Dialog/HostEdit";
import { baseURL } from "../../util/config";

const HostTable = (props) => {
  const dispatch = useDispatch();
  const { host } = useSelector((state) => state.host);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [genderFilter, setGenderFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    dispatch(getHost());
  }, [dispatch]);

  useEffect(() => {
    let filtered = host || [];

    if (genderFilter !== "all") {
      filtered = filtered.filter(
        (h) => (h?.gender || "").toLowerCase() === genderFilter.toLowerCase()
      );
    }

    if (statusFilter !== "all") {
      if (statusFilter === "online") {
        filtered = filtered.filter((h) => h?.isOnline === true);
      } else if (statusFilter === "offline") {
        filtered = filtered.filter((h) => h?.isOnline === false);
      } else if (statusFilter === "blocked") {
        filtered = filtered.filter((h) => h?.isBlock === true);
      }
    }

    if (search.trim()) {
      const q = search.trim().toUpperCase();
      filtered = filtered.filter((h) => {
        return (
          h?.name?.toUpperCase()?.includes(q) ||
          h?.email?.toUpperCase()?.includes(q) ||
          h?.gender?.toUpperCase()?.includes(q) ||
          h?.bio?.toUpperCase()?.includes(q) ||
          h?.country?.toUpperCase()?.includes(q) ||
          h?.uniqueID?.toString()?.toUpperCase()?.includes(q) ||
          h?.mobileNumber?.toString()?.includes(q)
        );
      });
    }

    setData(filtered);
    setPage(0);
  }, [host, genderFilter, statusFilter, search]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEdit = (data) => {
    dispatch({
      type: OPEN_HOST_DIALOG,
      payload: { mode: "edit", data },
    });
  };

  const handleOpen = () => {
    dispatch({
      type: OPEN_HOST_DIALOG,
      payload: { mode: "add" },
    });
  };

  const history = useHistory();

  const handleInfo = (hostId) => {
    history.push({ pathname: "/admin/host/hostProfile", state: { hostId } });
  };

  const handleClick = (host) => {
    props.disableHost(host);
  };

  const handleHistory = (id) => {
    sessionStorage.setItem("hostId", id);
    history.push({ pathname: "/admin/host/history", state: { hostId: id } });
  };

  const isRealEmail = (val) => {
    if (!val || typeof val !== "string") return false;
    const clean = val.trim().toLowerCase();
    if (clean === "flirtzy@gmail.com" || clean === "support@flirtzy.tech") return false;
    return clean.includes("@");
  };

  const getHostContact = (h) => {
    if (isRealEmail(h?.email)) {
      return h.email;
    }
    if (h?.mobileNumber && typeof h.mobileNumber === "string" && h.mobileNumber.trim().length >= 5) {
      return h.mobileNumber.trim();
    }
    if (h?.uniqueID) {
      return h.uniqueID;
    }
    return "N/A";
  };

  return (
    <>
      <div className="row py-2">
        <div className="col-2">
          <h4 className="hostTitle"> Host </h4>
        </div>
        <div className="col-10">
          <div className="breadcrumb-four float-right">
            <ul className="breadcrumb">
              <li>
                <Link to="/admin/dashboard">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-home"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </Link>
              </li>
              <li className="active">
                <a href={() => false}> Host </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row layout-top-spacing">
        <div id="tableDropdown" className="col-lg-12 col-12 layout-spacing">
          <div className="statbox widget">
            <div className="widget-content widget-content-area">
              <div className="row">
                <div className="col-xl-8 col-md-8 col-sm-12 col-12">
                  <div className="d-flex align-items-center flex-wrap mt-2">
                    <button
                      className="btn btn-danger mr-3"
                      onClick={handleOpen}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      + Add Host
                    </button>
                    <div className="mr-3 my-1">
                      <select
                        className="form-control"
                        value={genderFilter}
                        onChange={(e) => setGenderFilter(e.target.value)}
                        style={{ minWidth: "120px" }}
                      >
                        <option value="all">All Genders</option>
                        <option value="female">Female</option>
                        <option value="male">Male</option>
                      </select>
                    </div>
                    <div className="mr-3 my-1">
                      <select
                        className="form-control"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        style={{ minWidth: "120px" }}
                      >
                        <option value="all">All Status</option>
                        <option value="online">Online</option>
                        <option value="offline">Offline</option>
                        <option value="blocked">Blocked</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-md-4 float-right col-sm-12 col-12 filtered-list-search">
                  <form className="form-inline my-2 my-lg-0 justify-content-center">
                    <div className="w-100">
                      <input
                        type="text"
                        className="w-100 form-control product-search br-30"
                        id="input-search"
                        placeholder="Search Host..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <button
                        className="btn bg-danger-gradient text-white"
                        type="button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-search"
                        >
                          <circle cx="11" cy="11" r="8"></circle>
                          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table text-center mb-4 table-striped">
                  <thead>
                    <tr className="text-center">
                      <th className="fw-bold">ID / UniqueID</th>
                      <th className="fw-bold">Image</th>
                      <th className="fw-bold">Name</th>
                      <th className="fw-bold">Email / Contact</th>
                      <th className="fw-bold">Gender</th>
                      <th className="fw-bold">Role</th>
                      <th className="fw-bold">Status</th>
                      <th className="fw-bold">Country</th>
                      <th className="fw-bold">Coin Balance</th>
                      <th className="fw-bold">Block / Disable</th>
                      <th className="fw-bold">Created At</th>
                      <th className="fw-bold">Edit</th>
                      <th className="fw-bold">Info</th>
                      <th className="fw-bold">History</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 ? (
                      (rowsPerPage > 0
                        ? data.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                        : data
                      ).map((item, i) => {
                        return (
                          <tr className="text-center" key={item?._id || i}>
                            <td>{item?.uniqueID || page * rowsPerPage + parseInt(i) + 1}</td>
                            <td>
                              <img
                                src={
                                  item?.image &&
                                  !item?.image.includes("male.png") &&
                                  !item?.image.includes("female.png") &&
                                  !item?.image.includes("noImage.png")
                                    ? item.image.startsWith("http")
                                      ? item.image
                                      : baseURL + item.image
                                    : item?.gender?.toLowerCase() === "male"
                                    ? maleImage
                                    : femaleImage
                                }
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    item?.gender?.toLowerCase() === "male"
                                      ? maleImage
                                      : femaleImage;
                                }}
                                alt="host"
                                draggable="false"
                                className="mx-auto table_image"
                                onClick={() => handleInfo(item?._id)}
                              />
                            </td>
                            <td>{item?.name || "-"}</td>
                            <td className={isRealEmail(item?.email) ? "text-lowercase" : ""}>
                              {getHostContact(item)}
                            </td>
                            <td>{item?.gender || "female"}</td>
                            <td>
                              <span
                                className="badge"
                                style={{
                                  backgroundColor: "#8e24aa",
                                  color: "#fff",
                                  padding: "4px 8px",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                }}
                              >
                                HOST
                              </span>
                            </td>
                            <td>
                              {item?.isOnline ? (
                                <span className="badge badge-success">Online</span>
                              ) : (
                                <span className="badge badge-danger">Offline</span>
                              )}
                            </td>
                            <td>{item?.country || "-"}</td>
                            <td>{item?.coin ?? 0}</td>
                            <td style={{ paddingBottom: "0px" }}>
                              <label className="switch s-icons s-outline s-outline-primary mr-2 mb-0">
                                <input
                                  type="checkbox"
                                  checked={item?.isBlock}
                                  onChange={() => handleClick(item)}
                                />
                                <span className="slider round"></span>
                              </label>
                            </td>
                            <td>
                              {item?.createdAt
                                ? dayjs(item.createdAt).format("DD MMM YYYY")
                                : "-"}
                            </td>
                            <td>
                              <button
                                className="btn btn-secondary"
                                onClick={() => handleEdit(item)}
                                title="Edit Host"
                              >
                                <i className="fas fa-edit" />
                              </button>
                            </td>
                            <td>
                              <button
                                className="btn btn-info"
                                onClick={() => handleInfo(item?._id)}
                                title="Host Profile"
                              >
                                <i className="fa fa-info"></i>
                              </button>
                            </td>
                            <td>
                              <button
                                className="btn btn-success"
                                onClick={() => handleHistory(item?._id)}
                                title="Host History"
                              >
                                <i className="fa fa-history"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="14" className="text-center">
                          No Data Found !
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <TablePagination
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  50,
                  100,
                  { label: "All", value: data?.length || 0 },
                ]}
                component="div"
                count={data?.length || 0}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </div>
          </div>
        </div>

        <HostEdit />
        <HostDialogue />
      </div>
    </>
  );
};

export default connect(null, { getHost, disableHost })(HostTable);
